export default function({ variants, optionTypes, onAddSuccess }) {
  return {
    variants: variants || [],
    optionTypes: optionTypes || [],
    selectedOptions: {},
    activeVariant: null,
    quantity: 1,
    userHasSelected: false,
    addingToCart: false,
    addError: null,
    onAddSuccess: onAddSuccess || async function (response) {
      await up.reload({ target: '#mini-cart' });
      this.miniCartOpen = true;
    },

    // --- Initialize defaults ---
    initDefaults() {
      var self = this;

      this.optionTypes.forEach(function (opt) {
        // Use default if valid
        if (opt.default) {
          var hasDefault = self.variants.some(function (v) {
            return v[opt.name] &&
              v[opt.name].slug === opt.default &&
              v.isAvailable;
          });
          if (hasDefault) self.selectedOptions[opt.name] = opt.default;
        }

        // Otherwise, first available
        if (!self.selectedOptions[opt.name]) {
          var firstAvailable = self.variants.find(function (v) {
            return v[opt.name] && v.isAvailable;
          });
          if (firstAvailable && firstAvailable[opt.name]) {
            self.selectedOptions[opt.name] = firstAvailable[opt.name].slug;
          }
        }
      });

      this.findVariant();
    },

    // --- Find valid variant ---
    findVariant() {
      var self = this;
      this.activeVariant = this.variants.find(function (v) {
        return self.optionTypes.every(function (opt) {
          return (
            v[opt.name] &&
            v[opt.name].slug === self.selectedOptions[opt.name] &&
            v.isAvailable
          );
        });
      }) || null;

      if(this.userHasSelected && this.activeVariant) {
        window.dispatchEvent(new Event('variant-selected'));
      }

      this.quantity = 1;
    },

    // --- List all unique options ---
    optionsFor(optionName) {
      var seen = {};
      var list = [];
      this.variants.forEach(function (v) {
        var opt = v[optionName];
        if (opt && !seen[opt.slug]) {
          seen[opt.slug] = true;
          list.push(opt);
        }
      });
      return list;
    },

    // --- Check if an option is enabled ---
    isOptionEnabled(optionName, optionSlug) {
      var self = this;
      return this.variants.some(function (v) {
        if (!v[optionName] || v[optionName].slug !== optionSlug || !v.isAvailable) {
          return false;
        }
        return self.optionTypes.every(function (opt) {
          if (opt.name === optionName) return true;
          var selected = self.selectedOptions[opt.name];
          return !selected || (v[opt.name] && v[opt.name].slug === selected);
        });
      });
    },

    // --- When an option changes ---
    selectOption(optionName, optionSlug) {
      var self = this;
      this.selectedOptions[optionName] = optionSlug;

      // Check if current combination exists, otherwise auto-correct
      var validVariant = this.variants.find(function (v) {
        return self.optionTypes.every(function (opt) {
          return (
            v[opt.name] &&
            v[opt.name].slug === self.selectedOptions[opt.name] &&
            v.isAvailable
          );
        });
      });

      if (!validVariant) {
        this.optionTypes.forEach(function (opt) {
          if (opt.name !== optionName) {
            var stillValid = self.variants.some(function (v) {
              return (
                v.isAvailable &&
                v[opt.name] &&
                v[opt.name].slug === self.selectedOptions[opt.name] &&
                self.optionTypes.every(function (innerOpt) {
                  if (innerOpt.name === opt.name) return true;
                  var sel = self.selectedOptions[innerOpt.name];
                  return !sel || (v[innerOpt.name] && v[innerOpt.name].slug === sel);
                })
              );
            });

            if (!stillValid) {
              var available = self.optionsFor(opt.name).filter(function (o) {
                return self.isOptionEnabled(opt.name, o.slug);
              });
              if (available.length > 0) {
                self.selectedOptions[opt.name] = available[0].slug;
              }
            }
          }
        });
      }

      this.userHasSelected = true;
      this.findVariant();
    },

    // --- Quantity controls ---
    incrementQty() {
      if (this.activeVariant && typeof this.activeVariant.stock === 'number') {
        if (this.quantity < this.activeVariant.stock) this.quantity++;
      } else {
        this.quantity++;
      }
    },

    decrementQty() {
      if (this.quantity > 1) this.quantity--;
    },

    // --- Stock helpers ---
    isOutOfStock() {
      return (
        !this.activeVariant ||
        !this.activeVariant.isAvailable ||
        (typeof this.activeVariant.stock === 'number' && this.activeVariant.stock < 1)
      );
    },

    // --- XHR form submission ---
    async submitForm(e) {
      var self = this;
      if (!this.activeVariant || this.isOutOfStock()) return;

      e.preventDefault(); // prevent normal submit only if JS is active
      this.addingToCart = true;
      this.addError = null;

      try {
        var formData = new FormData(e.target);

        var response = await fetch(e.target.action, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        var json = await response.json();

        if (json.success || json.cart) {
          self.onAddSuccess(json);
          self.quantity = 1;
        } else {
          self.addError = json.error || 'Unable to add item to cart.';
        }
      } catch (error) {
        self.addError = error.message;
      } finally {
        self.addingToCart = false;
      }
    }
  };
}
